import { model as routerModel } from '!/router'
import { createEvent, restore, sample } from 'effector'
import { or } from 'patronum'
import { model as rootEntity } from '~/entities/shows/root'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

const $isAnyInitFxPending = or(
  rootEntity.getBannersFx.pending,
  rootEntity.getFeaturedCarouselFx.pending,
  rootEntity.initCategoriesWithShowsFx.pending,
  rootEntity.initShowBundlesRowByPageFx.pending,
  rootEntity.initInfiniteShowsCategoryFx.pending
)

sample({
  clock: $isAnyInitFxPending,
  source: routerModel.$pathname,
  filter: (pathname) => pathname === '/modules/tv_shows',
  fn: (_, isAnyInitFxPending) => isAnyInitFxPending,
  target: setContentLoading,
})
